import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  timeout: 20000,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Only clear on auth check endpoints; login/register bad creds shouldn't force-logout
      const url = err.config?.url || '';
      if (url.includes('/auth/me') || url.includes('/admin/') || url.includes('/employee/') || url.includes('/owner/')) {
        localStorage.removeItem('token');
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(e, fallback = 'Something went wrong') {
  const d = e?.response?.data;
  if (!d) return e?.message || fallback;
  if (typeof d.error === 'string') return d.error;
  if (typeof d.message === 'string') return d.message;
  return fallback;
}

export default api;
